import React, { useState } from 'react'
import { OrganizationDashboardExperience } from '../OrganizationDashboardExperience'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      refetchOnMount: false,
      useErrorBoundary: true,
    },
  },
})

export const SalesDashboard = ({ organizations, ffp_dashboard }) => {
  const [selectedOrganization, setSelectedOrganization] = useState(null)
  const [dashboardData, setDashboardData] = useState(null)
  const [searchQuery, setSearchQuery] = useState('')

  const handleOrganizationClick = (organization) => {
    setSelectedOrganization(organization)
    fetch(`/api/organization_dashboard?scope=month&organization_id=${organization.id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
      }
    })
      .then((response) => response.json())
      .then((data) => {
        setDashboardData(data)
      })
      .catch((error) => {
        console.error('Error fetching dashboard data:', error)
      })
  }

  if (!selectedOrganization) {
    const thStyle = {
      textAlign: 'left',
      padding: '11px 22px',
      background: '#FAFBFC',
      borderBottom: '1px solid #EEF1F4',
      fontSize: '11px',
      fontWeight: 600,
      letterSpacing: '0.5px',
      textTransform: 'uppercase',
      color: '#98A2B3',
    }
    const tdStyle = {
      padding: '13px 22px',
      borderTop: '1px solid #F2F4F7',
      fontSize: '14px',
      fontWeight: 600,
      color: '#101828',
      verticalAlign: 'middle',
    }
    const viewBtnStyle = {
      WebkitAppearance: 'none',
      appearance: 'none',
      padding: '7px 16px',
      border: 'none',
      borderRadius: '10px',
      background: 'var(--tenant-color-cta)',
      color: '#FFFFFF',
      fontSize: '13px',
      fontWeight: 600,
      cursor: 'pointer',
    }

    const filteredOrganizations = organizations
      .filter((org) => org.name.toLowerCase().includes(searchQuery.trim().toLowerCase()))
      .sort((a, b) => a.name.localeCompare(b.name))

    return (
      <div style={{ maxWidth: '760px', margin: '0 auto', padding: '32px 24px 60px' }}>
        <h1 style={{ margin: '0 0 20px', fontSize: '22px', fontWeight: 650, letterSpacing: '-0.2px' }}>
          Select an organization
        </h1>
        <input
          type="search"
          placeholder="Search organizations…"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          style={{
            width: '100%',
            boxSizing: 'border-box',
            margin: '0 0 16px',
            padding: '10px 14px',
            border: '1px solid #E7EAEE',
            borderRadius: '10px',
            fontSize: '14px',
            color: '#101828',
            background: '#FFFFFF',
          }}
        />
        <div style={{
          background: '#FFFFFF',
          border: '1px solid #E7EAEE',
          borderRadius: '14px',
          boxShadow: '0 1px 2px rgba(16, 24, 40, 0.04)',
          overflow: 'hidden',
        }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', margin: 0 }}>
            <thead>
              <tr>
                <th style={thStyle}>Organization</th>
                <th style={{ ...thStyle, textAlign: 'right' }}>Onboarded clients</th>
                <th style={{ ...thStyle, textAlign: 'right' }}></th>
              </tr>
            </thead>
            <tbody>
              {filteredOrganizations.map((org) => (
                <tr key={org.id}>
                  <td style={tdStyle}>{org.name}</td>
                  <td style={{ ...tdStyle, textAlign: 'right' }}>{org.onboarded_clients_count}</td>
                  <td style={{ ...tdStyle, textAlign: 'right' }}>
                    <button
                      type="button"
                      style={viewBtnStyle}
                      onClick={() => handleOrganizationClick(org)}
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))}
              {filteredOrganizations.length === 0 && (
                <tr>
                  <td style={{ ...tdStyle, fontWeight: 400, color: '#98A2B3' }} colSpan={3}>
                    No organizations match "{searchQuery}"
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    )
  }

  if (!dashboardData) { return 'loading..' }

  return (
    <QueryClientProvider client={queryClient}>
      <OrganizationDashboardExperience
        organization={selectedOrganization}
        initialData={dashboardData}
        incognito={true}
        ffp_dashboard={ffp_dashboard}
      />
    </QueryClientProvider>
  )
}
